/* eslint-disable @typescript-eslint/no-explicit-any */
import { IDictionaryValue } from 'APIPackage/DictionariesModule/interfaces/IDictionaryValue';
import { IDictionaryValues } from 'APIPackage/DictionariesModule/interfaces/IDictionaryValues';
import { IApplicationConditionSubject } from 'APIPackage/AccountModule/interfaces/IApplicationConditionSubject';

import { createDictionaryAcceptedDocumentSelectOption } from '../common/createDictionaryAcceptedDocumentSelectOption';
import { createDictionaryChecklistSelectOption } from '../common/createDictionaryChecklistSelectOption';
import { createDictionaryEventTypeSelectOption } from '../common/createDictionaryEventTypeSelectOption';
import { createDictionaryKnoOrganizationSelectOption } from '../common/createDictionaryKnoOrganizationSelectOption';
import { createDictionaryKnmKindSelectOption } from '../common/createDictionaryKnmKindSelectOption';
import { createDictionaryPermitDocsSelectOption } from '../common/createDictionaryPermitDocsSelectOption';
import { createDictionaryPositionSelectOption } from '../common/createDictionaryPositionSelectOption';
import { createDictionaryProfKindSelectOption } from '../common/createDictionaryProfKindSelectOption';
import { createDictionaryRequirementSelectOption } from '../common/createDictionaryRequirementSelectOption';
import { createDictionaryRiskCategorySelectOption } from '../common/createDictionaryRiskCategorySelectOption';
import { createDictionaryDangerClassSelectOption } from '../common/createDictionaryDangerClassSelectOption';
import { createDictionaryRiskIndicatorySelectOption } from '../common/createDictionaryRiskIndicatorySelectOption';
import { createDictionarySubjectTypeSelectOption } from '../common/createDictionarySubjectTypeSelectOption';
import { createDictionarySubjectKindSelectOption } from '../common/createDictionarySubjectKindSelectOption';
import { createDictionarySubjectSubKindSelectOption } from '../common/createDictionarySubjectSubKindSelectOption';
import { createDictionarySupervisionTypeSelectOption } from '../common/createDictionarySupervisionTypeSelectOption';
import { createDictionaryParticipantPositionSelectOption } from '../common/createDictionaryParticipantPositionSelectOption';
import { DictionaryNamesEnum } from '../enums/DictionaryNamesEnum';
import { IDictionarySelectOption } from '../interfaces/IDictionarySelectOption';
import { createDictionaryErvkSelectOption } from '../common/createDictionaryErvkSelectOption';
import { IPermitDocs } from '../../../APIPackage/DictionariesModule/interfaces/IPermitDocs';
import { createDictionaryDecisionKindSelectOption } from '../common/createDictionaryDecisionKindSelectOption';
import { createErvkChecklistSelectOption } from '../common/createErvkChecklistSelectOption';
import { IErvkCheckList } from '../../../APIPackage/DictionariesModule/interfaces/IErvkCheckList';
import { IKnmReasonType } from '../../../APIPackage/CatalogsModule/interfaces/IKnmReasonType';
import { createDictionaryFederalLawSelectOption } from '../common/createDictionaryFederalLawSelectOption';
import { createDictionaryKnmSubjectTypesSelectOption } from '../common/createDictionaryKnmSubjectTypesSelectOption';
import { createDictionaryKnoLevelSelectOption } from '../common/createDictionaryKnoLevelSelectOption';

export const createDictionarySelectOptionByNameMap: Record<
  DictionaryNamesEnum,
  (
    dictionaryId: IDictionaryValues<any>['idDictionary'], // ToDo: fix 'any'
    dictionaryValue:
      | IDictionaryValue<any>
      | IPermitDocs[]
      | IErvkCheckList[]
      | IKnmReasonType[]
      | IApplicationConditionSubject[], // ToDo: fix 'any'
  ) => IDictionarySelectOption<any> // ToDo: fix 'any'
> = {
  [DictionaryNamesEnum.ACCEPTED_DOCUMENT]: createDictionaryAcceptedDocumentSelectOption,
  [DictionaryNamesEnum.CHECKLIST]: createDictionaryChecklistSelectOption,
  [DictionaryNamesEnum.EVENT_TYPE]: createDictionaryEventTypeSelectOption,
  [DictionaryNamesEnum.PM_PROF_EVENT_TYPE]: createDictionaryEventTypeSelectOption,
  [DictionaryNamesEnum.KNO_ORGANIZATIONS]: createDictionaryKnoOrganizationSelectOption,
  [DictionaryNamesEnum.KNM_KIND]: createDictionaryKnmKindSelectOption,
  [DictionaryNamesEnum.DECISION_KIND]: createDictionaryDecisionKindSelectOption,
  [DictionaryNamesEnum.DECISION_KIND_ALL]: createDictionaryDecisionKindSelectOption,
  [DictionaryNamesEnum.POSITIONS]: createDictionaryPositionSelectOption,
  [DictionaryNamesEnum.PERMIT_DOCS]: createDictionaryPermitDocsSelectOption,
  [DictionaryNamesEnum.PARTICIPANT_POSITIONS]: createDictionaryParticipantPositionSelectOption,
  [DictionaryNamesEnum.PROF_KIND]: createDictionaryProfKindSelectOption,
  [DictionaryNamesEnum.REQUIREMENT]: createDictionaryRequirementSelectOption,
  [DictionaryNamesEnum.RISK_CATEGORY]: createDictionaryRiskCategorySelectOption,
  [DictionaryNamesEnum.DANGER_CLASS]: createDictionaryDangerClassSelectOption,
  [DictionaryNamesEnum.RISK_INDICATORY]: createDictionaryRiskIndicatorySelectOption,
  [DictionaryNamesEnum.SUBJECT_TYPE]: createDictionarySubjectTypeSelectOption,
  [DictionaryNamesEnum.SUBJECT_KIND]: createDictionarySubjectKindSelectOption,
  [DictionaryNamesEnum.SUBJECT_SUB_KIND]: createDictionarySubjectSubKindSelectOption,
  [DictionaryNamesEnum.SUPERVISION_TYPE]: createDictionarySupervisionTypeSelectOption,
  [DictionaryNamesEnum.FEDERAL_LAWS]: createDictionaryFederalLawSelectOption,
  [DictionaryNamesEnum.KNO_LEVELS]: createDictionaryKnoLevelSelectOption,
  [DictionaryNamesEnum.KNM_SUBJECT_TYPES]: createDictionaryKnmSubjectTypesSelectOption,
  [DictionaryNamesEnum.ERVK]: createDictionaryErvkSelectOption,
  [DictionaryNamesEnum.TARGET_ENTITY]: () => null,
  [DictionaryNamesEnum.TARGET_ENTITY_FOUNDER]: () => null,
  [DictionaryNamesEnum.KNM_TYPES]: () => null,
  [DictionaryNamesEnum.ERVK_CHECK_LIST]: () => createErvkChecklistSelectOption,
  [DictionaryNamesEnum.CONDITION_TYPES]: () => null,
  [DictionaryNamesEnum.APPLICATION_CONDITION_SUBJECTS]: () => null,
  [DictionaryNamesEnum.SUPERVISION_TYPE_BY_SUBJECT_TYPE]: createDictionarySupervisionTypeSelectOption,
};
